import { useQuery } from '@tanstack/react-query'
import { supabase } from '../lib/supabase'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const db = (t: string): any => (supabase as any).from(t)

// Count of purchase orders placed but not yet received — goods in transit
// awaiting receipt. Same predicate as the Buy → In Transit view
// (`delivery_status = 'in_transit'`, not cancelled), so the Trading badge and
// that list reconcile. Gate with `enabled` for users who can't see the tab.
export function useUnreceivedPurchaseCount(tid: string, enabled = true) {
  return useQuery<number>({
    queryKey: ['unreceived-purchase-count', tid],
    enabled: !!tid && enabled,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: true,
    queryFn: async () => {
      const { count } = await db('purchase_orders')
        .select('id', { count: 'exact', head: true })
        .eq('tenant_id', tid)
        .eq('delivery_status', 'in_transit')
        .neq('status', 'cancelled')
      return count ?? 0
    },
  })
}
